import { css, styled } from 'next-yak';

import { createPolymorphicElement } from '@xing-com/polymorphic-element';
import { spaceS } from '@xing-com/tokens';

import { SkeletonRectangle } from '../';

import type { SkeletonBodyCopyAlignment } from './skeleton-body-copy.types';

type BodyCopyTransientProps = {
  $alignment?: SkeletonBodyCopyAlignment;
};

type BodyCopyRowTransientProps = {
  $amountRows: number;
};

// *** Text Alignments ***
export const alignments = {
  left: css`
    justify-content: flex-start;
  `,
  center: css`
    justify-content: center;
  `,
  right: css`
    justify-content: flex-end;
  `,
};

// *** Components ***
const BodyCopyElement = createPolymorphicElement('div');

export const BodyCopy = styled(BodyCopyElement)<BodyCopyTransientProps>`
  display: flex;
  flex-wrap: wrap;
  ${({ $alignment }) => {
    switch ($alignment) {
      case 'left':
        return alignments.left;
      case 'center':
        return alignments.center;
      case 'right':
        return alignments.right;
      default:
        return $alignment satisfies undefined;
    }
  }};
`;

export const BodyCopyRow = styled(SkeletonRectangle)<BodyCopyRowTransientProps>`
  margin-block-end: ${spaceS};

  ${({ $amountRows }) =>
    $amountRows > 1 &&
    css`
      &:last-child {
        width: 66%;
      }
    `};

  &:last-child {
    margin-block-end: 0;
  }
`;
